export class PaletteColor {
  flossId; //paletteColorId;
  flossName; //paletteColorName;
  flossHtml; //paletteColorHex;
  flossDisplayOrder; //paletteColorOrder;

  constructor(jsonData) {
    Object.assign(this, jsonData);
  }
}
